'use client';
import { useEffect } from 'react';
import { mixpanelProductImpression } from '@/lib/mixpanel/services/client';
import { useStatsigClient } from '@statsig/react-bindings';

type ProductProps = {
  title?: string;
  product?: {
    sanityTitle?: string;
    title?: string;
    slug?: string;
    categorySlug?: string;
    price?: number;
    compareAtPrice?: number;
    variantGid?: string;
    previewImageUrl?: string;
  };
  component?: string;
};

export default function MixpanelProductImpression({
  title,
  product,
  component,
}: ProductProps) {
  const { logEvent } = useStatsigClient();

  // Track product impression
  useEffect(() => {
    if (title !== '') {
      mixpanelProductImpression({
        product: {
          ...product,
          sanityTitle: title,
        },
      });
      logEvent('product_impression', title, {
        event_source: 'Online',
        currency_code: 'ZAR',
        price: product ? `${product.price}` : '0',
        name: title ? title : '',
        category: product?.categorySlug
          ? product.categorySlug.replace(/-/g, ' ')
          : '',
        component: component ? component : 'unknown',
      });
    }
  }, [title, product]);

  return null;
}
